import { useMemo } from 'react'
import type { ParsedDataCandleStick, RegionBarGraphData } from './typings'

type RegressionLineKey = keyof RegionBarGraphData | keyof ParsedDataCandleStick
// Inspired by https://github.com/jprichardson/least-squares/blob/master/lib/least-squares.js

export const useRegressionLineForData = (
  regressionLineKey: RegressionLineKey,
  data: RegionBarGraphData[] | ParsedDataCandleStick[]
): number[] => {
  const regressionLine = useMemo(() => {
    const X = data.map((d) => d.id)
    const Y = data.map((d) => (d as any)[regressionLineKey] as number)
    const N = data.length

    let sumX = 0
    let sumY = 0
    let sumXY = 0
    let sumXX = 0

    for (let i = 0; i < N; ++i) {
      sumX += X[i]
      sumY += Y[i]
      sumXY += X[i] * Y[i]
      sumXX += X[i] * X[i]
    }

    const m = (sumXY - (sumX * sumY) / N) / (sumXX - (sumX * sumX) / N)
    const b = sumY / N - (m * sumX) / N

    const lineValues = data.map((d) => m * d.id + b)
    return lineValues
  }, [regressionLineKey, data])
  return regressionLine
}
